import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'redux';

import { Loader, Paper, Title } from 'redpoints-front-components/index';

import {
  socialMediaMessagesClear,
  socialMediaMessagesFetchMessages,
} from '../../actions/socialMediaMessagesActions';
import {
  getSocialMediaMessagesIsLoading,
  getSocialMediaMessagesNextMessages,
  getSocialMediaMessagesPreviousMessages,
} from '../../reducers/socialMediaMessages';
import './SocialMediaMessages.less';
import SocialMediaMessagesList from './SocialMediaMessagesList';
import { translate } from '../../helpers/languageHelper';

const SocialMediaMessages = ({
  isLoading,
  nextMessages,
  previousMessages,
  socialMediaMessagesClear,
  socialMediaMessagesFetchMessages,
  match: {
    params: { detectionLinkId },
  },
}) => {
  useEffect(() => {
    socialMediaMessagesFetchMessages(detectionLinkId);
  }, [socialMediaMessagesFetchMessages, detectionLinkId]);

  useEffect(() => {
    return () => {
      socialMediaMessagesClear();
    };
  }, [socialMediaMessagesClear]);

  const hasPreviousMessages = previousMessages && previousMessages.length;
  const hasNextMessages = nextMessages && nextMessages.length;

  return (
    <Paper className="social-media-messages">
      <Loader isLoading={isLoading}>
        {hasPreviousMessages && (
          <SocialMediaMessagesList messages={previousMessages} />
        )}
        <Title>{translate('social_media_messages.detectedMessage')}</Title>
        {hasNextMessages && (
          <SocialMediaMessagesList messages={nextMessages} isNextMessage />
        )}
      </Loader>
    </Paper>
  );
};

const mapStateToProps = state => ({
  isLoading: getSocialMediaMessagesIsLoading(state),
  previousMessages: getSocialMediaMessagesPreviousMessages(state),
  nextMessages: getSocialMediaMessagesNextMessages(state),
});

export default compose(
  connect(mapStateToProps, {
    socialMediaMessagesClear,
    socialMediaMessagesFetchMessages,
  }),
  withRouter
)(SocialMediaMessages);
